<template>
  <div>
    <UIModal id="model" v-model:show="showModalNative" :width="860">
      <template #header>
        <UIModalHeader
          id="model-header"
          :title="t(`${i18nPath}.shareOrEmbed`)"
          @close="closeEditor"
        >
        </UIModalHeader>
      </template>
      <UIModalContent>
        <section
          class="layout-container"
          :class="[
            store.formId ? 'h-[670px]' : 'h-[280px]',
            activeShareType === SHARE_TYPE.EMBED_CODE ? 'relative' : '',
          ]"
        >
          <ShareType
            @share-type:change="
              (id) => {
                activeShareType = id;
              }
            "
          ></ShareType>
          <div
            class="w-[1px] bg-[#EAECF0]"
            :class="[store.formId ? 'h-[670px]' : 'h-[250px]']"
          ></div>
          <Embed
            v-if="activeShareType === SHARE_TYPE.EMBED_CODE"
            :widget-name="widgetName"
            :widget-id="widgetId"
          ></Embed>
          <Share
            v-if="activeShareType === SHARE_TYPE.SHARE"
            :widget-name="widgetName"
            :widget-id="widgetId"
            :base-url="baseUrl"
          ></Share>
          <Email v-if="activeShareType === SHARE_TYPE.EMAIL" :widget-id="widgetId"></Email>
        </section>
      </UIModalContent>
    </UIModal>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { UIModal, UIModalContent, UIModalHeader } from "@gohighlevel/ghl-ui";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { PRODUCT_TYPE, SHARE_TYPE } from "../../../util/constants";
import Email from "./Email.vue";
import Embed from "./Embed.vue";
import Share from "./Share.vue";
import ShareType from "./ShareType.vue";

const { t } = useI18n();
const store = useAppStore();

const props = defineProps({
  formName: {
    type: String,
    default: "",
  },
  modelActive: {
    type: Boolean,
    default: false,
  },
  formLayoutSettings: Object,
  isWhiteLabelled: {
    type: Boolean,
    default: false,
  },
  baseUrl: {
    type: String,
    default: "",
  },
});

const showModalNative = ref(props.modelActive);

const activeShareType = ref(1);

const i18nPath = computed(() => {
  return store.formId
    ? "form.integratePopup"
    : store.surveyId
    ? "survey.integratePopup"
    : "quiz.integratePopup";
});
watch(
  () => showModalNative.value,
  (newValue) => {
    emit("update:showModel", newValue);
  }
);

const emit = defineEmits(["update:showModel", "update:submit", "update:cancel", "update:close"]);

const closeEditor = () => {
  showModalNative.value = false;
  emit("update:close", true);
};

const widgetName = computed(() => {
  return store.formId
    ? PRODUCT_TYPE.FORM
    : store.surveyId
    ? PRODUCT_TYPE.SURVEY
    : PRODUCT_TYPE.QUIZ;
});
const widgetId = computed(() => {
  return store.formId || store.surveyId || store.quizId;
});
</script>
<style scoped>
.layout-container {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex: 1 0 0;
  align-self: stretch;
}
</style>
